import moment from 'moment';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import { useAnalyticsInterval } from '@treams/treams-hooks/src/useAnalyticsInterval';
import { Paragraph, Tooltip } from '@treams/treams-ui';

import { DeltaState, EngagementDelta } from './EngagementDelta';

type Props = {
	delta: number | null;
};

export const EngagementDeltaTooltip: FC<Props> = ({ delta }) => {
	const { t } = useTranslation();
	const { interval, startDate } = useAnalyticsInterval();

	const translationMap: Record<string, () => string> = {
		month: () => t('dashboard.metrics.engagement.metric.previous.month'),
		quarter: () => t('dashboard.metrics.engagement.metric.previous.quarter'),
		year: () => t('dashboard.metrics.engagement.metric.previous.year'),
		custom: () =>
			t('dashboard.metrics.engagement.metric.previous.days', {
				days: moment().diff(moment(startDate), 'days'),
			}),
	};

	const translationPrefixMap = {
		increase: t('dashboard.metrics.engagement.metric.increase'),
		decline: t('dashboard.metrics.engagement.metric.decline'),
		neutral: t('dashboard.metrics.engagement.metric.neutral'),
	};

	let deltaState: DeltaState = 'neutral';

	if (delta) {
		deltaState = delta > 0 ? 'increase' : 'decline';
	}

	const translationPrefix = translationPrefixMap[deltaState]
		? translationPrefixMap[deltaState]
		: '';

	const translationPostfix = translationMap[interval] ? translationMap[interval]() : '';

	return (
		<Box style={{ position: 'relative' }}>
			<Tooltip
				position="right"
				content={<Paragraph>{`${translationPrefix} ${translationPostfix}`}</Paragraph>}
			>
				<EngagementDelta delta={delta} />
			</Tooltip>
		</Box>
	);
};
